import React from 'react';

const SafetyGear = () => {
  return (
    <div>
      <h1>Safety Gear</h1>
      <h2><strong>Hardstand hut safety gear</strong></h2>
      <p>RBYC has a safety cupboard that contains the following:</p>
      <ul>
        <li>emergency contact numbers</li>
        <li>safety equipment and supplies.</li>
      </ul>
      <h3><strong>Locations</strong></h3>
      <ul>
        <li>The pier hardyard hut is accessible with a membership key</li>
        <li>On the corridor wall outside Mens/Womens change rooms</li>
      </ul>
      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default SafetyGear;
